import type { LabelInValue } from 'models';
import { useTranslation } from 'react-i18next';
import { Select, type SelectProperties } from '../select';

type P<ValueType extends LabelInValue, OptionType extends ValueType> = {
  onChange?: (value?: ValueType | ValueType[]) => void;
} & Omit<SelectProperties<ValueType, OptionType>, 'labelInValue' | 'onChange'>;

const OptionSelect = <ValueType extends LabelInValue, OptionType extends ValueType = ValueType>({
  onChange,
  placeholder,
  ...props
}: P<ValueType, OptionType>) => {
  const { t } = useTranslation();

  return (
    <Select<ValueType, OptionType>
      onChange={(_, b) => {
        onChange?.(b);
      }}
      optionFilterProp="label"
      placeholder={typeof placeholder === 'string' ? t(placeholder) : placeholder}
      {...props}
      labelInValue
    />
  );
};

export default OptionSelect;
